import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

const FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScQoEXeUJBRRm-z9qsErJiVy3N0UIlaY1JB6YcdPsuxqUDg_Q/viewform";

const SALURAN = [
  "Surat fisik (non elektronik), dialamatkan ke kantor LLDIKTI Wilayah VII, Jl. Dr. Ir. H. Soekarno, 177 Surabaya - 60117",
  "Surat elektronik, dikirim ke alamat: ult.lldikti7@kemdikbud.go.id",
  "Atau melalui Formulir dibawah ini:",
];

export default function PengajuanInformasi() {
  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Layanan Informasi — Pengajuan Informasi Publik
          </p>
          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            Pengajuan Informasi Publik
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <Reveal delay={0.1}>
          <div className="max-w-3xl text-[15px] leading-relaxed text-slate-600 md:text-base">
            <p data-testid="pengajuan-text-1">
              LLDIKTI Wilayah VII sebagai organisasi pemerintahan wajib
              melayani setiap permohonan informasi publik sesuai yang diatur
              dalam Undang-Undang Nomor 14 Tahun 2008 tentang Keterbukaan
              Informasi Publik.
            </p>
            <p data-testid="pengajuan-text-2" className="mt-6">
              Dalam pengajuan permohonan informasi publik, mohon untuk membaca
              terlebih dahulu persyaratan yang harus dipenuhi dalam
              permohonan, sebagai berikut:
            </p>

            <ol
              data-testid="pengajuan-list"
              className="mt-8 list-decimal space-y-5 pl-6 marker:font-semibold marker:text-[#0B2440]"
            >
              <li>
                Dokumen Identitas Diri :
                <ul className="mt-3 list-[lower-alpha] space-y-2 pl-6 marker:text-slate-500">
                  <li>KTP atau Identitas resmi lainnya, jika Pemohon adalah perseorangan</li>
                  <li>
                    Dokumen Pengesahan Institusi jika pemohon adalah Badan
                    Hukum Non Perguruan Tinggi Swasta
                  </li>
                  <li>
                    Surat Permohonan Resmi yang ditanda-tangani pejabat yang
                    berwenang jika pemohon adalah instansi pemerintahan
                  </li>
                </ul>
              </li>
              <li>
                Menyertakan di dalam permohonannya, penjelasan atas
                kepentingan/tujuan permohonan informasi yang diajukan
              </li>
              <li>
                Menyertakan PERIHAL/SUBJEK dalam Permohonan : PERMOHONAN
                INFORMASI PUBLIK
              </li>
              <li>
                Menyampaikan permohonan melalui minimal dari salah satu
                saluran berikut:
                <div className="mt-3 space-y-2 pl-1 sm:pl-6">
                  {SALURAN.map((t, i) => (
                    <p key={i} className="flex gap-2">
                      <span className="font-semibold text-[#0B2440]">
                        {i + 1})
                      </span>
                      <span>
                        {t.includes("ult.lldikti7@kemdikbud.go.id") ? (
                          <>
                            Surat elektronik, dikirim ke alamat:{" "}
                            <a
                              href="mailto:ult.lldikti7@kemdikbud.go.id"
                              className="font-medium text-[#1479BF] hover:underline"
                            >
                              ult.lldikti7@kemdikbud.go.id
                            </a>
                          </>
                        ) : (
                          t
                        )}
                      </span>
                    </p>
                  ))}
                </div>
              </li>
            </ol>

            <div className="mt-10 flex justify-center">
              <a
                href={FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="pengajuan-form-button"
                className="inline-flex items-center justify-center rounded-full bg-[#1479BF] px-8 py-4 text-xs font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#0B2440] md:text-sm"
              >
                Ajukan Permohonan Informasi Publik
              </a>
            </div>
          </div>
        </Reveal>
      </main>
      <Footer compact />
    </div>
  );
}
